import { render, staticRenderFns } from "./Lang4.vue?vue&type=template&id=4ab32370&scoped=true&"
import script from "./Lang4.vue?vue&type=script&lang=js&"
export * from "./Lang4.vue?vue&type=script&lang=js&"
import style0 from "./Lang4.vue?vue&type=style&index=0&id=4ab32370&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab32370",
  null
  
)

export default component.exports